export default class OverlappingCampaignsListCode {

	public constructCampaignEditorLink(campaignId: number): string {
		return `${window.location.origin}/campaign-editor/#/general/${campaignId}/`;
	}
}
